export default __webpack_public_path__ + "static/media/line.c5724534.png";